import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useNavigate, Link } from 'react-router-dom';
import Footer from "./Footer";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ZMCMConveyanceDetails = () => {
    const [profile, setProfile] = useState(null);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [visitRows, setVisitRows] = useState([]);
    const [selectedMonthType, setSelectedMonthType] = useState("current");
    const [branches, setBranches1] = useState([]); // State to hold branch options
    const [allBranches, setBranches] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();

    const currentMonth = new Date().toLocaleString("en-US", { month: "long" });
    // Load profile first
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const res = await fetch(`${API_BASE_URL}profile`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });

                const result = await res.json();
                if (result.status && result.profile) {
                    setProfile(result.profile);
                    fetchDetails(result.profile.emp_code);
                } else {
                    setMessage("Unable to load profile");
                    setLoading(false);
                }
            } catch (error) {
                setMessage("Failed to load profile");
                setLoading(false);
            }
        };
        fetchProfile();
    }, []);

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch(`${API_BASE_URL}getBranches`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
                const result = await response.json();
                if (result.status) {
                    const formattedBranches = result.data.map(branch => ({
                        value: branch.SysNo, // assuming `SysNo` is unique for each branch
                        label: `${branch.SysField}`, // assuming `SysField` is the branch name
                    }));
                    setBranches(formattedBranches);
                } else {
                    toast.error('Failed to fetch branches');
                }
            } catch (error) {
                console.error('Failed to fetch branches', error);
                toast.error('Failed to load branches');
            }
        };

        fetchBranches();
    }, []); // Fetch branches on component mount

    // Fetch details
    const fetchDetails = async (empCode) => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}getcmzmdetails/${empCode}`, {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });

            const result = await response.json();

            if (result.status && result.data.status === "success") {
                const row = result.data.data[0];
                setDetails([row]);

                const branchArray = row.branches_list || [];
                const role = row.role;

                // 🔹 Decide visits per branch based on role
                const visitsPerBranch =
                    role === "cluster_manager" ? 2 : 1;

                // 🔹 Total visits
                const totalVisits = branchArray.length * visitsPerBranch;

                // 🔹 Amount split
                const totalAmount = parseFloat(row.amount);
                setTotalAmount(totalAmount);
                const perVisitAmount = totalAmount / totalVisits;
                const displayAmount = Number(perVisitAmount).toFixed(2);
                const visits = [];

                branchArray.forEach((b) => {
                    for (let visitNo = 1; visitNo <= visitsPerBranch; visitNo++) {
                        visits.push({
                            visit_no: visitNo,
                            branch_id: b.id,
                            branch_name: b.name,
                            date: "",
                            from_time: "",
                            to_time: "",
                            day: "",
                            purpose: "",
                            remarks: "",
                            amount: displayAmount,
                            attachment: null,
                        });
                    }
                });

                setVisitRows(visits);
            } else {
                setMessage(result.data?.message || "No conveyance records found");
            }
        } catch (err) {
            setMessage("Failed to load conveyance details");
        } finally {
            setLoading(false);
        }
    };

    // Date & Day auto-fill
    const handleDateChange = (index, value) => {
        const updated = [...visitRows];
        updated[index].date = value;

        const d = new Date(value);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        updated[index].day = days[d.getDay()];

        setVisitRows(updated);
    };

    const handleTimeChange = (index, field, value) => {
        const updated = [...visitRows];

        if (field === "to_time" && updated[index].from_time) {
            if (value < updated[index].from_time) {
                alert("To time cannot be earlier than From time");
                return;
            }
        }

        updated[index][field] = value;
        setVisitRows(updated);
    };

    // Purpose / Remarks update
    const handleInputChange = (index, field, value) => {
        const updated = [...visitRows];
        updated[index][field] = value;
        setVisitRows(updated);
    };

    const handleFileChange = (index, file) => {
        const updated = [...visitRows];
        updated[index].attachment = file;
        setVisitRows(updated);

    };
    const getSelectedMonthYear = () => {
        const now = new Date();

        const baseDate =
            selectedMonthType === "current"
                ? now
                : new Date(now.getFullYear(), now.getMonth() - 1, 1);

        const month = String(baseDate.getMonth() + 1).padStart(2, "0"); // MM
        const year = baseDate.getFullYear(); // YYYY

        return `${month}-${year}`; // eg: 12-2025
    };

    const getSelectedMonthYear1 = () => {
        const now = new Date();

        const baseDate =
            selectedMonthType === "current"
                ? now
                : new Date(now.getFullYear(), now.getMonth() - 1, 1);

        const monthName = baseDate.toLocaleString("en-US", {
            month: "short", // Jan, Feb, Mar...
        });

        const year = baseDate.getFullYear();

        return `${monthName}-${year}`; // Dec-2025
    };

    const handleSubmit = async (actionType) => {
        if (!profile) {
            alert("Profile not loaded");
            return;
        }

        const selectedRows = visitRows.filter(v => v.date);

        if (selectedRows.length === 0) {
            alert("Please select at least one visit date");
            return;
        }

        for (let i = 0; i < selectedRows.length; i++) {
            const v = selectedRows[i];

            if (!v.purpose.trim()) {
                alert(`Please enter Purpose for Visit ${v.visit_no} - ${v.branch_name}`);
                return;
            }

            // Amount validation ONLY for original rows
            if (!v.isAdded) {
                if (!v.amount || Number(v.amount) == 0) {
                    alert(`Invalid amount for Visit ${v.visit_no} - ${v.branch_name}`);
                    return;
                }
            }
        }

        const formData = new FormData();
        const monthYear = getSelectedMonthYear();
        formData.append("emp_code", profile.emp_code);
        formData.append("employee_name", profile.comp_name);
        formData.append("role", details[0]?.role || "");
        formData.append("duration", details[0]?.duration_type || "");
        formData.append("visit_count", selectedRows.length);
        formData.append("submission_type", actionType);
        formData.append("totalAmount", totalAmount);
        formData.append("month_year", getSelectedMonthYear());
        

        selectedRows.forEach((v, i) => {
            const finalBranchName =
  v.branch_id === "OTHERS"
    ? v.other_branch
    : v.branch_name;
            formData.append(`visits[${i}][visit_no]`, v.visit_no);
            formData.append(`visits[${i}][branch_id]`, v.branch_id);
            formData.append(`visits[${i}][branch_name]`, finalBranchName);
            formData.append(`visits[${i}][date]`, v.date);
            formData.append(`visits[${i}][from_time]`, v.from_time);
            formData.append(`visits[${i}][to_time]`, v.to_time);
            formData.append(`visits[${i}][day]`, v.day);
            formData.append(`visits[${i}][purpose]`, v.purpose);
            formData.append(`visits[${i}][remarks]`, v.remarks);
            formData.append(`visits[${i}][amount]`, v.amount || 0);


            if (v.attachment) {
                formData.append(`visits[${i}][attachment]`, v.attachment);
            }
        });

        try {
            const token = localStorage.getItem("authToken");

            const res = await fetch(`${API_BASE_URL}save_zmcm_conveyance`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const result = await res.json();

            if (result.status === true || result.status === "success") {
                alert("✅ Conveyance submitted successfully!");
                setIsSubmitted(true);
                navigate(`/manage_cmzmconveyance`);
            } else {
                alert(result.message || "❌ Submission failed");
            }
        } catch (err) {
            console.error(err);
            alert("❌ Server error while submitting");
        }
    };


    const branchIndexMap = {};
    let branchCounter = 0;

    visitRows.forEach((row) => {
        if (!branchIndexMap[row.branch_name]) {
            branchIndexMap[row.branch_name] = branchCounter;
            branchCounter++;
        }
    });

    const formatDateLocal = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    // Get first & last date of allowed month
    const getMonthDateRange = () => {
        const now = new Date();

        let startDate, endDate;

        if (selectedMonthType === "current") {
            startDate = new Date(now.getFullYear(), now.getMonth(), 1);
            endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        } else {
            startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        }

        return {
            min: formatDateLocal(startDate),
            max: formatDateLocal(endDate),
        };
    };

    const { min, max } = getMonthDateRange();

const getVisitBg = (branchName) => {
    const index = branchIndexMap[branchName] ?? 0;

    // Even index → LIGHT, Odd index → DARK
    if (index % 2 === 0) {
        return {
            background: "rgb(212, 246, 255)", // LIGHT
            border: "1px solid rgb(180, 230, 245)",
        };
    }

    return {
        background: "rgb(124, 164, 240)", // DARK
        border: "1px solid rgb(170, 140, 225)",
        color: "#ffffff", // ensure text visibility
    };
};




    const handleAddRow = () => {
        const newRow = {
            visit_no: 1,
            branch_id: "",
            branch_name: "",
            other_branch: "",
            date: "",
            from_time: "",
            to_time: "",
            day: "",
            purpose: "",
            remarks: "",
            attachment: null,
            amount: "",
            isAdded: true,
        };

        setVisitRows([...visitRows, newRow]);
    };

    const handleBranchChange = (index, value) => {
  const updated = [...visitRows];

  if (value === "OTHERS") {
    updated[index].branch_id = "OTHERS";
    updated[index].branch_name = "Others";
    updated[index].other_branch = "";
  } else {
    const selected = allBranches.find(b => b.value === value);
    updated[index].branch_id = value;
    updated[index].branch_name = selected?.label || "";
    updated[index].other_branch = "";
  }

  setVisitRows(updated);
};

const handleOtherBranchChange = (index, value) => {
  const updated = [...visitRows];
  updated[index].other_branch = value;
  setVisitRows(updated);
};

    const handleRemoveRow = (index) => {
        const updated = [...visitRows];
        updated.splice(index, 1);
        setVisitRows(updated);
    };


    if (loading) {
        return <h3 style={{ padding: 20, color: "#6ca0dc" }}>Loading...</h3>;
    }

    return (
        <div className="hold-transition sidebar-mini layout-fixed"
            style={{ background: "#f4f7fb", fontSize: '12px' }}>
            <div className="wrapper">

                <Header />
                <Sidebar />

                <div className="content-wrapper" style={{ padding: "25px" }}>

                    {/* PAGE TITLE */}
                    <h2 style={{
                        color: "#6ca0dc",
                        fontWeight: "800",
                        fontSize: "24px",
                        marginBottom: "12px"
                    }}>
                        Conveyance Details
                    </h2>

                    {/* MESSAGE */}
                    {message && (
                        <div style={{
                            padding: "12px",
                            background: "#fdeeee",
                            borderLeft: "4px solid #d87a7a",
                            borderRadius: "8px",
                            marginBottom: "18px",
                            color: "#8b3f3f",
                        }}>
                            {message}
                        </div>
                    )}

                    {/* PROFILE CARD */}
                    {profile && (
                        <div
                            style={{
                                background: "#ffffffee",
                                padding: "15px 20px",
                                borderRadius: "12px",
                                border: "1px solid #e2e8f5",
                                marginBottom: "20px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",

                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "20px", // 👈 space between items
                                }}
                            >
                                <b style={{ color: "#557a95" }}>Employee:</b>{" "}
                                {profile.comp_name} ({profile.emp_code})

                                <label>
                                    <input
                                        type="radio"
                                        value="current"
                                        checked={selectedMonthType === "current"}
                                        onChange={() => setSelectedMonthType("current")}
                                    />{" "}
                                    Current Month
                                </label>

                                <label>
                                    <input
                                        type="radio"
                                        value="previous"
                                        checked={selectedMonthType === "previous"}
                                        onChange={() => setSelectedMonthType("previous")}
                                    />{" "}
                                    Previous Month
                                </label>

                                <span
                                    style={{
                                        color: "rgb(108, 160, 220)",
                                        fontWeight: "700",
                                    }}
                                >
                                    <b>Selected Month:</b> {getSelectedMonthYear1()}
                                </span>
                            </div>
                        </div>
                    )}

                    {details.length > 0 && (
                        <div style={{
                            background: "#ffffffee",
                            padding: "15px 20px",
                            borderRadius: "12px",
                            border: "1px solid #d9e3f1",
                            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            marginBottom: "25px"
                        }}>
                            {details.map((row, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "22px",
                                        fontSize: "14px",
                                        color: "#425b70",
                                    }}
                                >
                                    <span><b>ID:</b> {row.id}</span>
                                    <span><b>Role:</b> {row.role}</span>
                                    <span><b>Duration:</b> {row.duration_type} days</span>
                                    <span><b>Total Branches:</b> {row["1_30_cnt"]}</span>
                                    <span><b>Amount:</b> ₹{row.amount}</span>
                                    <span><b>Branches:</b> {row.branches}</span>
                                    <span><b>Created:</b> {row.created_on}</span>


                                </div>
                            ))}
                        </div>
                    )}

                    {/* VISIT RECORDS */}
                    <h3 style={{ color: "#557a95", fontSize: "15px", marginBottom: "8px" }}>
                        Visit Records ({visitRows.length} Visits)
                    </h3>

                    <div
                        style={{
                            maxHeight: "500px",
                            overflowY: "auto",
                            background: "#ffffffee",
                            borderRadius: "10px",
                            border: "1px solid #d9e3f1",
                            padding: "10px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        {visitRows.map((row, index) => (
                            <div
                                key={index}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "12px",
                                    padding: "8px 10px",
                                    marginBottom: "8px",
                                    borderRadius: "8px",
                                    fontSize: "12.5px",
                                    ...getVisitBg(row.branch_name), // 🎨 color by V1 / V2
                                }}
                            >
                                {/* Visit No */}
                                <span style={{ width: "60px" }}>
                                    <b>V:</b> {row.visit_no}
                                </span>

                                {/* Branch ID */}
                                {/* <span style={{ width: "70px" }}>
                                    <b>ID:</b> {row.branch_id}
                                </span> */}

                                {/* Branch Name */}
                                {/* <span style={{ width: "180px", whiteSpace: "nowrap" }}>
                                    <b>Branch:</b> {row.branch_name}
                                </span> */}
                               {row.isAdded ? (
  <>
    {/* Branch Select */}
    <select
      value={row.branch_id}
      onChange={(e) => handleBranchChange(index, e.target.value)}
      style={{
        width: "180px",
        height: "26px",
        fontSize: "12px",
        borderRadius: "4px",
        border: "1px solid #9ad1d4",
      }}
    >
      <option value="">Select Branch</option>

      {allBranches.map((b) => (
        <option key={b.value} value={b.value}>
          {b.label}
        </option>
      ))}

      {/* 👇 OTHERS OPTION */}
      <option value="OTHERS">Others</option>
    </select>

    {/* 👇 Show input only if Others selected */}
    {row.branch_id === "OTHERS" && (
      <input
        type="text"
        placeholder="Enter purpose (e.g. Court appearance)"
        value={row.other_branch || ""}
        onChange={(e) =>
          handleOtherBranchChange(index, e.target.value)
        }
        style={{
          width: "180px",
          height: "26px",
          fontSize: "12px",
          marginTop: "4px",
          borderRadius: "4px",
          border: "1px solid #9ad1d4",
          padding: "0 6px",
        }}
      />
    )}
  </>
) : (
  <span style={{ width: "180px", whiteSpace: "nowrap" }}>
    <b>Branch:</b>{" "}
    {row.branch_id === "OTHERS"
      ? row.other_branch
      : row.branch_name}
  </span>
)}



                                {/* Date */}
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <b style={{ marginRight: "4px" }}>Date:</b>
                                    <input
                                        type="date"
                                        value={row.date}
                                        min={min}
                                        max={max}
                                        onChange={(e) => handleDateChange(index, e.target.value)}
                                        style={{
                                            fontSize: "12px",
                                            padding: "3px",
                                            height: "26px",
                                            borderRadius: "4px",
                                            border: "1px solid #9ad1d4",
                                        }}
                                    />
                                </div>

                                {/* Day */}
                                <span style={{ width: "65px" }}>
                                    <b>Day:</b> {row.day}
                                </span>

                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <b>From:</b>

                                    {/* From Time */}
                                    <input
                                        type="time"
                                        value={row.from_time || ""}
                                        onChange={(e) =>
                                            handleTimeChange(index, "from_time", e.target.value)
                                        }
                                        style={{
                                            fontSize: "12px",
                                            padding: "3px",
                                            height: "26px",
                                            borderRadius: "4px",
                                            border: "1px solid #9ad1d4",
                                        }}
                                    />

                                    <span style={{ fontSize: "11px", fontWeight: "600" }}><b>to</b></span>

                                    {/* To Time */}
                                    <input
                                        type="time"
                                        value={row.to_time || ""}
                                        min={row.from_time || ""}
                                        onChange={(e) =>
                                            handleTimeChange(index, "to_time", e.target.value)
                                        }
                                        style={{
                                            fontSize: "12px",
                                            padding: "3px",
                                            height: "26px",
                                            borderRadius: "4px",
                                            border: "1px solid #9ad1d4",
                                        }}
                                    />
                                </div>

                                {/* Purpose */}
                                <input
                                    type="text"
                                    placeholder="Purpose"
                                    value={row.purpose}
                                    onChange={(e) => handleInputChange(index, "purpose", e.target.value)}
                                    style={{
                                        width: "240px",
                                        fontSize: "12px",
                                        padding: "4px",
                                        height: "26px",
                                        borderRadius: "4px",
                                        border: "1px solid #9ad1d4",
                                    }}
                                />

                                {/* Remarks */}
                                <input
                                    type="text"
                                    placeholder="Remarks"
                                    value={row.remarks}
                                    onChange={(e) => handleInputChange(index, "remarks", e.target.value)}
                                    style={{
                                        width: "240px",
                                        fontSize: "12px",
                                        padding: "4px",
                                        height: "26px",
                                        borderRadius: "4px",
                                        border: "1px solid #9ad1d4",
                                    }}
                                />

                                {/* Amount */}
                                {row.amount && (
                                    <span
                                        style={{
                                            background: "#6ca0dc",
                                            color: "#fff",
                                            padding: "3px 10px",
                                            borderRadius: "14px",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        ₹{row.amount}
                                    </span>
                                )}



                                {/* Attachment */}
                                <input
                                    type="file"
                                    accept="image/*,application/pdf"
                                    onChange={(e) => handleFileChange(index, e.target.files[0])}
                                    style={{
                                        fontSize: "11px",
                                    }}
                                />

                                {row.isAdded && (
                                    <span
                                        onClick={() => handleRemoveRow(index)}
                                        style={{
                                            cursor: "pointer",
                                            color: "#d9534f",
                                            fontSize: "16px",
                                            fontWeight: "700",
                                            marginLeft: "6px",
                                        }}
                                        title="Remove this visit"
                                    >
                                        ❌
                                    </span>
                                )}
                            </div>

                        ))}
                        {/* ➕ Add New Visit */}

                        <div
                            onClick={handleAddRow}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px",
                                padding: "10px",
                                borderRadius: "8px",
                                border: "2px dashed #6ca0dc",
                                color: "#6ca0dc",
                                fontWeight: "700",
                                cursor: "pointer",
                                marginTop: "10px",
                                background: "#f7fbff",
                            }}
                        >
                            <span style={{ fontSize: "18px" }}>➕</span>
                            <span>Add New Visit</span>
                        </div>

                    </div>

                    <div
  style={{
    textAlign: "center",
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
  }}
>
  {/* ❌ Cancel */}
  <button
    onClick={() => navigate("/manage_cmzmconveyance")}
    style={{
      background: "#6c757d",
      color: "#fff",
      padding: "12px 36px",
      fontSize: "15px",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "700",
      boxShadow: "0 4px 12px rgba(108,117,125,0.4)",
    }}
  >
    ❌ Cancel
  </button>

  {/* 💾 Save Draft */}
  <button
    onClick={() => handleSubmit("draft")}
    style={{
      background: "linear-gradient(135deg, #5a8dee, #6ca0dc)",
      color: "#fff",
      padding: "12px 36px",
      fontSize: "15px",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "700",
      boxShadow: "0 4px 12px rgba(90,141,238,0.4)",
    }}
  >
    💾 Save as Draft
  </button>

  {/* 🚀 Approval */}
  <button
    onClick={() => handleSubmit("approval")}
    style={{
      background: "linear-gradient(135deg, #34a853, #4caf50)",
      color: "#fff",
      padding: "12px 36px",
      fontSize: "15px",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      fontWeight: "700",
      boxShadow: "0 4px 12px rgba(52,168,83,0.4)",
    }}
  >
    🚀 Send for Approval
  </button>
</div>



                </div>

                <Footer />
            </div>
        </div>
    );
};

export default ZMCMConveyanceDetails;
